import React from 'react';
import { Truck, CheckCircle2 } from 'lucide-react';
import { useCart } from '../../context/CartContext';
import { STORE_CONFIG } from '../../config/storeConfig';

export const FreeShippingBar: React.FC<{ compact?: boolean }> = ({ compact = false }) => {
  const { subtotal, hasFreeShipping, remainingForFreeShipping } = useCart();
  const threshold = STORE_CONFIG.freeShippingThreshold;
  const progressPercent = Math.min(100, Math.round((subtotal / threshold) * 100));

  return (
    <div
      id="free-shipping-tracker"
      className={`w-full ${
        compact
          ? 'bg-blue-50/70 p-3 rounded-lg border border-blue-100'
          : 'bg-[#F8FAFC] p-4 rounded-xl border border-[#E2E8F0]'
      }`}
    >
      <div className="flex items-center justify-between gap-2 mb-2">
        <div className="flex items-center gap-1.5 sm:gap-2 min-w-0">
          {hasFreeShipping ? (
            <CheckCircle2 className="w-4 h-4 sm:w-5 sm:h-5 text-emerald-600 shrink-0" />
          ) : (
            <Truck className="w-4 h-4 sm:w-5 sm:h-5 text-[#191975] shrink-0" />
          )}
          <span className="text-[11px] sm:text-xs md:text-sm font-semibold text-[#172554] truncate sm:overflow-visible">
            {hasFreeShipping ? (
              <span className="text-emerald-700 font-bold">
                🎉 FREE SHIPPING Unlocked!
              </span>
            ) : (
              <span>
                Add{' '}
                <strong className="text-[#191975]">
                  {STORE_CONFIG.formatPrice(remainingForFreeShipping)}
                </strong>{' '}
                for <strong className="text-emerald-600">FREE SHIPPING</strong>
              </span>
            )}
          </span>
        </div>
        <span className="text-[11px] sm:text-xs font-bold text-[#64748B] shrink-0">{progressPercent}%</span>
      </div>

      {/* Visual Progress Bar */}
      <div className="w-full h-2 bg-slate-200 rounded-full overflow-hidden">
        <div
          className={`h-full transition-all duration-500 rounded-full ${
            hasFreeShipping ? 'bg-emerald-500' : 'bg-[#191975]'
          }`}
          style={{ width: `${progressPercent}%` }}
        />
      </div>
    </div>
  );
};
